export class PreCheckError extends Error {
  readonly errorCode: string
  constructor(errorCode: string) {
    super(`Pre check error. Error code: ${errorCode}`)
    this.errorCode = errorCode
  }
}
